import { render, staticRenderFns } from "./VideosTable.vue?vue&type=template&id=4cdc6651&scoped=true"
import script from "./VideosTable.vue?vue&type=script&lang=ts"
export * from "./VideosTable.vue?vue&type=script&lang=ts"
import style0 from "./VideosTable.vue?vue&type=style&index=0&id=4cdc6651&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cdc6651",
  null
  
)

export default component.exports